<template>
  <div class="page-content">
    <div class="content-wrapper">
      <div class="content-inner">
        <div class="content d-flex justify-content-center align-items-center">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Layout',
}
</script>
